export default __webpack_public_path__ + "static/media/arkguide_07.e31d29fd.gif";